export default __webpack_public_path__ + "static/media/375.fa466bf6.jpg";